import type { TypographyOptions } from '@material-ui/core/styles/createTypography';

import FontWeights from './fontWeights';

/**
 * https://material-ui.com/customization/typography/
 */
const typography: TypographyOptions = {
  fontFamily: ['TT Norms Pro', 'Roboto', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontSize: '2rem',
    lineHeight: '2.5rem',
    fontWeight: FontWeights.Bold,
  },
  h2: {
    fontSize: '1.625rem',
    lineHeight: '2.5rem',
    fontWeight: FontWeights.SemiBold,
  },
  h3: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.SemiBold,
  },
  h4: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.SemiBold,
  },
  h5: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.Bold,
  },
  h6: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.Medium,
  },
  subtitle1: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: FontWeights.Normal,
  },
  subtitle2: {
    fontSize: '0.75rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.Normal,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.Normal,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: FontWeights.Normal,
  },
  button: {
    fontSize: '0.875rem',
    lineHeight: '0.875rem',
    fontWeight: FontWeights.SemiBold,
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: FontWeights.Normal,
  },
  overline: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: FontWeights.Normal,
  },
};

export default typography;
